import { useStaffMe } from "../../hooks/useStaffMe";

/**
 * The `staff` guard (behaviour-logging FRS §6.1 FR22; access-tiers TR §7.8,
 * §13.4): rendered by `AccessGate` for a signed-in user on a route whose
 * feature carries `guards: ["staff"]`.
 *
 * Asks GET /api/v1/staff/me — which also claims a pending invite, so an
 * invitee's first visit just works — and renders:
 *
 * - while it is in flight: the spinner, never the page, so no staff data
 *   flashes before the answer;
 * - 403: the "no access" card (`renderShell({ noAccess: true })`);
 * - a network error or a 5xx: a retry card;
 * - 200: `children` (the gate's `<Outlet />`, i.e. the lazy staff page).
 *
 * UX only. The real gate is `require_staff` on every staff endpoint.
 */
const StaffGuard = ({ children, spinner, renderShell }) => {
  const me = useStaffMe();

  if (me.isPending) return spinner;
  if (me.isError && !me.data) {
    return renderShell({
      error: true,
      retrying: me.isFetching,
      onRetry: () => me.refetch(),
    });
  }
  if (!me.data?.staff) return renderShell({ noAccess: true });
  return children;
};

export default StaffGuard;
